
import React from 'react';
import { Job } from "@/components/jobs/types";
import { Label } from "@/components/ui/label";

interface JobReferenceIdFieldProps {
  job: Pick<Job, 'reference_id'>;
}

export const JobReferenceIdField: React.FC<JobReferenceIdFieldProps> = ({ job }) => {
  if (!job.reference_id) {
    return null;
  }
  return (
    <div>
      <Label className="text-xs font-medium text-muted-foreground">Reference ID</Label>
      <p>{job.reference_id}</p>
    </div>
  );
};
